/*if(document.querySelector(".blog-post-content")){
  document.querySelector(".blog-post-content").innerHTML += `<div class="author-box" style="margin-bottom:20px;"><a href="https://grupobelleza.com/blogs/news" class="author-box__avatar" style="border: none;"><img src="https://cdn.shopify.com/s/files/1/0570/6235/9158/files/Monica_Escruela_430x.jpg?v=1750250012" alt=“Mònica Escruela” style="width:62px;height:62px;margin-right:25px;"/></a><div class="author-box__text" style="font-size:17px;"><div class="author-box__name" style="font-size:24px;margin-bottom:10px;"><a href="https://grupobelleza.com/blogs/news" style="border: none;">Mònica Escruela</a></div><div class="author-box__bio" style="margin-bottom:20px;"><a href="https://www.linkedin.com/in/monica-escruela-m%C3%A1rquez-9262a9245/" style="border: none;"><img src="https://cdn.shopify.com/s/files/1/0405/0501/6485/files/LinkedIn_logo_initials_430x.png?v=1725892030" alt="LinkedIn"style="height: 20px;border-radius: 0;padding-right:5px;margin-bottom: -5px;"/>Head of Sales & Marketing</a> </div><a href="https://grupobelleza.com/blogs/news" class="author-box__button" style="font-size:14px;text-transform:uppercase;font-weight:500;padding:6px 15px;background:#000000;color:#FFFFFF;border: none;">Más artículos </a></div></div>`
}*/

/* ============================================================
   NOTIFY ME! PREVENTA — textos de la ficha y del carrito
   La app escribe la fecha como 2026-10-02, sin opción de cambiarla.
   - Ficha y carrito: la fecha pasa a "2 de octubre de 2026".
   - Ficha: el cartel PREVENTA pasa del precio a las fotos.
   - Carrito: el aviso "TIEMPO DE ENTREGA" sale con cualquier producto
     en preventa, no solo cuando se mezcla con productos en stock.
   - Idiomas: la traducción de textos de la app va con candado (plan de
     pago), así que en en/de/fr/it/nl el cartel, el botón, la frase de la
     fecha y el aviso se ponen aquí. El español sale tal cual de la app
     (solo se corrige el "Hacer un pedido" del cartel de la portada).
   - Carrito: "Disponibilidad prevista:" pasa a "El producto se
     enviará a partir del", la línea "Pago: ..." se oculta y el
     nombre del plan ("preorder") pasa a "PRODUCTO EN PREVENTA".
   Todo en el idioma de la tienda (es, en, de, fr, it, nl).
   En el checkout y en el pedido siguen los textos de la app.
   ============================================================ */
(function () {
  var SELECTOR_FECHAS = '.hengam-preorder-description, .hengam-featured-product-description, .cart-items__properties dd';
  var FECHA_ISO = /\b(\d{4})-(\d{2})-(\d{2})\b/g;
  var idioma = (document.documentElement.lang || 'es').slice(0, 2);

  // Etiquetas que la app pone a las propiedades de la línea, en todos los idiomas
  var ETIQUETAS_FECHA = ['Disponibilidad prevista', 'Expected availability', 'Voraussichtliche Verfügbarkeit', 'Disponibilité prévue', 'Disponibilità prevista', 'Verwachte beschikbaarheid'];
  var ETIQUETAS_PAGO = ['Pago', 'Payment', 'Zahlung', 'Paiement', 'Pagamento', 'Betaling'];
  // Textos que pone la app por defecto (se sustituyen solo si coinciden)
  var APP_CARTEL = ['PREVENTA', 'Hacer un pedido', 'Pre-order', 'Vorbestellen', 'Pré-commander', 'Ordine prestabilito', 'Voorafgaande bestelling'];
  var APP_BOTON = ['PREVENTA', 'Reserva ahora', 'Pre-order now', 'jetzt vorbestellen', 'Pré commandez maintenant', 'Preordinalo ora', 'Bestel nu vooraf'];
  var APP_AVISO_TITULO = ['Shipping Notice', 'TIEMPO DE ENTREGA'];
  var APP_AVISO_TEXTO = ['Your order contains items with different delivery dates.', 'Tu pedido se enviará cuando todos los productos en preventa estén disponibles.'];
  // ficha y aviso a null en español: ahí manda lo que se escriba en la app
  var TEXTOS = {
    es: { envio: 'El producto se enviará a partir del', preventa: 'PRODUCTO EN PREVENTA', cartel: 'PREVENTA', boton: 'PREVENTA', ficha: null, avisoTitulo: null, avisoTexto: null },
    en: { envio: 'This product will ship from', preventa: 'PRE-ORDER PRODUCT', cartel: 'PRE-ORDER', boton: 'PRE-ORDER', ficha: 'This item will ship from {fecha}', avisoTitulo: 'DELIVERY TIME', avisoTexto: 'Your order will ship once all pre-order items are available.' },
    de: { envio: 'Versand ab dem', preventa: 'VORBESTELLUNG', cartel: 'VORBESTELLUNG', boton: 'VORBESTELLUNG', ficha: 'Wir versenden diesen Artikel ab dem {fecha}', avisoTitulo: 'LIEFERZEIT', avisoTexto: 'Deine Bestellung wird versendet, sobald alle vorbestellten Artikel verfügbar sind.' },
    fr: { envio: 'Expédition à partir du', preventa: 'PRODUIT EN PRÉCOMMANDE', cartel: 'PRÉCOMMANDE', boton: 'PRÉCOMMANDE', ficha: 'Nous expédierons cet article à partir du {fecha}', avisoTitulo: 'DÉLAI DE LIVRAISON', avisoTexto: 'Votre commande sera expédiée dès que tous les articles en précommande seront disponibles.' },
    it: { envio: 'Spedizione a partire dal', preventa: 'PRODOTTO IN PREORDINE', cartel: 'PREORDINE', boton: 'PREORDINE', ficha: 'Spediremo questo articolo a partire dal {fecha}', avisoTitulo: 'TEMPI DI CONSEGNA', avisoTexto: 'Il tuo ordine verrà spedito quando tutti i prodotti in preordine saranno disponibili.' },
    nl: { envio: 'Verzending vanaf', preventa: 'PRODUCT IN VOORVERKOOP', cartel: 'VOORVERKOOP', boton: 'VOORVERKOOP', ficha: 'We verzenden dit artikel vanaf {fecha}', avisoTitulo: 'LEVERTIJD', avisoTexto: 'Je bestelling wordt verzonden zodra alle voorverkoopartikelen beschikbaar zijn.' }
  };
  var textos = TEXTOS[idioma] || TEXTOS.es;
  var formato;

  try {
    formato = new Intl.DateTimeFormat(idioma, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC'
    });
  } catch (error) {
    return;
  }

  function formatearFecha(texto, anio, mes, dia) {
    var fecha = new Date(Date.UTC(+anio, +mes - 1, +dia));
    return isNaN(fecha.getTime()) ? texto : formato.format(fecha);
  }

  function formatearElemento(elemento) {
    var recorrido = document.createTreeWalker(elemento, NodeFilter.SHOW_TEXT);
    var nodo;
    while ((nodo = recorrido.nextNode())) {
      if (/\d{4}-\d{2}-\d{2}/.test(nodo.nodeValue)) {
        nodo.nodeValue = nodo.nodeValue.replace(FECHA_ISO, formatearFecha);
      }
    }
  }

  // Cambia el primer texto con contenido del elemento si es uno de los de la
  // app. Se toca el nodo de texto existente (no se reemplaza) para que la app
  // pueda seguir actualizándolo, por ejemplo al cambiar de talla.
  function cambiarTexto(elemento, conocidos, nuevo) {
    if (!nuevo) return;
    var recorrido = document.createTreeWalker(elemento, NodeFilter.SHOW_TEXT);
    var nodo;
    while ((nodo = recorrido.nextNode())) {
      var actual = nodo.nodeValue.trim();
      if (!actual) continue;
      if (actual !== nuevo && conocidos.indexOf(actual) !== -1) nodo.nodeValue = nuevo;
      return;
    }
  }

  function ajustarDescripcion(elemento) {
    // "Expected availability: 2026-10-15 / Payment: ..." pasa a la frase propia
    if (!textos.ficha) return;
    var recorrido = document.createTreeWalker(elemento, NodeFilter.SHOW_TEXT);
    var nodo;
    while ((nodo = recorrido.nextNode())) {
      var fecha = nodo.nodeValue.match(/(\d{4})-(\d{2})-(\d{2})/);
      if (fecha) nodo.nodeValue = textos.ficha.replace('{fecha}', formatearFecha(fecha[0], fecha[1], fecha[2], fecha[3]));
    }
  }

  function ajustarTextosApp() {
    document.querySelectorAll('.hengam-preorder-badge, .hengam-featured-product-badge, .hengam-preorder-collection-badge, .hengam-preorder-landing-badge').forEach(function (e) { cambiarTexto(e, APP_CARTEL, textos.cartel); });
    document.querySelectorAll('.hengam-preorder-button, .hengam-featured-product-button').forEach(function (e) { cambiarTexto(e, APP_BOTON, textos.boton); });
    document.querySelectorAll('.hengam-preorder-description, .hengam-featured-product-description').forEach(ajustarDescripcion);
    document.querySelectorAll('.nm-mixed-cart-alert__title').forEach(function (e) { cambiarTexto(e, APP_AVISO_TITULO, textos.avisoTitulo); });
    document.querySelectorAll('.nm-mixed-cart-alert__body').forEach(function (e) { cambiarTexto(e, APP_AVISO_TEXTO, textos.avisoTexto); });
  }

  function ajustarPropiedad(fila) {
    var dt = fila.querySelector('dt');
    if (!dt) return;
    var etiqueta = dt.textContent.trim().replace(/:$/, '').trim();
    if (ETIQUETAS_PAGO.indexOf(etiqueta) !== -1) {
      if (fila.style.display !== 'none') fila.style.display = 'none';
    } else if (ETIQUETAS_FECHA.indexOf(etiqueta) !== -1) {
      dt.textContent = textos.envio + ' ';
    }
  }

  function ajustarPlan(parrafo) {
    // Párrafo con el nombre del plan de venta, justo debajo de las propiedades
    if (parrafo.textContent.trim() !== textos.preventa) parrafo.textContent = textos.preventa;
  }

  function ajustarFicha() {
    // La app pone su cartel junto al precio solo si la talla elegida está en
    // preventa; se copia su texto a la galería para mostrarlo sobre las fotos
    var galeria = document.querySelector('media-gallery');
    if (!galeria) return;
    var cartel = document.querySelector('.hengam-product-price-wrapper .hengam-preorder-badge');
    var texto = cartel ? cartel.textContent.trim() : '';
    if (texto) {
      var valor = JSON.stringify(texto);
      if (galeria.style.getPropertyValue('--muare-preventa') !== valor) galeria.style.setProperty('--muare-preventa', valor);
      if (!galeria.hasAttribute('data-preventa')) galeria.setAttribute('data-preventa', '');
    } else if (galeria.hasAttribute('data-preventa')) {
      galeria.removeAttribute('data-preventa');
    }
  }

  function ajustarAvisoCarrito() {
    // La app solo muestra "TIEMPO DE ENTREGA" si el carrito mezcla preventa
    // y stock; se marca <html> cuando hay cualquier línea en preventa (la que
    // lleva el párrafo del plan) y el CSS lo muestra también en ese caso
    var hayPreventa = !!document.querySelector('.cart-items .cart-items__variants + p');
    var raiz = document.documentElement;
    if (hayPreventa !== raiz.hasAttribute('data-carrito-preventa')) raiz.toggleAttribute('data-carrito-preventa', hayPreventa);
  }

  // Se ejecuta dentro del propio MutationObserver (antes de pintar), así el
  // cliente no llega a ver los textos originales cuando el carrito se recarga.
  // Cada ajuste solo cambia algo la primera vez, así que no entra en bucle.
  function revisar() {
    ajustarTextosApp();
    ajustarFicha();
    ajustarAvisoCarrito();
    document.querySelectorAll('.cart-items__properties').forEach(ajustarPropiedad);
    document.querySelectorAll('.cart-items__details .cart-items__variants + p').forEach(ajustarPlan);
    document.querySelectorAll(SELECTOR_FECHAS).forEach(formatearElemento);
  }

  new MutationObserver(revisar).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  revisar();
})();

/* ============================================================
   FICHA DE PRODUCTO — barra de compra fija abajo en móvil
   Cuando el botón de compra queda atrás (por encima de la pantalla)
   aparece abajo una barra con la cantidad y el mismo botón (como en
   delamur.com); antes de llegar a él, no. La
   barra no compra por su cuenta: pulsa el botón real del tema, así
   sigue funcionando todo lo que cuelga de él (preventa, cajón del
   carrito, avisos). Copia su texto y si está desactivado (Agotado).
   ============================================================ */
(function () {
  var MOVIL = window.matchMedia('(max-width: 749px)');

  function iniciar() {
    var detalles = document.querySelector('.product-details');
    var boton = detalles && detalles.querySelector('add-to-cart-component button[type="submit"]');
    if (!boton) return;
    var cantidad = detalles.querySelector('quantity-selector-component input[name="quantity"]');

    var barra = document.createElement('div');
    barra.className = 'muare-barra-compra';
    barra.innerHTML =
      (cantidad ? '<div class="muare-barra-compra__cantidad">' +
        '<button type="button" data-paso="-1" aria-label="-">&minus;</button>' +
        '<input type="number" inputmode="numeric" min="1" value="1" aria-label="Cantidad">' +
        '<button type="button" data-paso="1" aria-label="+">+</button>' +
      '</div>' : '') +
      '<button type="button" class="muare-barra-compra__boton"></button>';
    document.body.appendChild(barra);

    var botonBarra = barra.querySelector('.muare-barra-compra__boton');
    var cantidadBarra = barra.querySelector('input');

    function sincronizarBoton() {
      var texto = (boton.innerText || boton.textContent).trim().split('\n')[0].trim();
      if (botonBarra.textContent !== texto) botonBarra.textContent = texto;
      if (botonBarra.disabled !== boton.disabled) botonBarra.disabled = boton.disabled;
    }

    function pasarCantidad(valor) {
      valor = Math.max(1, parseInt(valor, 10) || 1);
      if (cantidadBarra) cantidadBarra.value = valor;
      if (cantidad && cantidad.value !== String(valor)) {
        cantidad.value = valor;
        cantidad.dispatchEvent(new Event('input', { bubbles: true }));
        cantidad.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    barra.addEventListener('click', function (evento) {
      var paso = evento.target.closest('[data-paso]');
      if (paso) pasarCantidad((parseInt(cantidadBarra.value, 10) || 1) + parseInt(paso.dataset.paso, 10));
    });
    if (cantidadBarra) cantidadBarra.addEventListener('change', function () { pasarCantidad(cantidadBarra.value); });
    botonBarra.addEventListener('click', function () { if (!boton.disabled) boton.click(); });

    // Se muestra cuando el botón real ya quedó por encima de la pantalla (solo en móvil)
    var raiz = document.documentElement;
    var botonPasado = false;
    function actualizarVisibilidad() {
      var mostrar = MOVIL.matches && botonPasado;
      if (mostrar && cantidad && cantidadBarra) cantidadBarra.value = cantidad.value || 1;
      if (mostrar !== raiz.hasAttribute('data-barra-compra')) raiz.toggleAttribute('data-barra-compra', mostrar);
      if (mostrar) raiz.style.setProperty('--muare-barra-alto', barra.offsetHeight + 'px'); // lo que sube lo que flota en las esquinas
      raiz.toggleAttribute('data-cta-sin-pasar', MOVIL.matches && !botonPasado); // hasta pasar el botón, chat y lista se esconden (ESQUINAS en el CSS)
    }
    // La pantalla se alarga hacia abajo: el botón solo deja de cruzarla al quedar por encima, aunque el salto sea de golpe
    new IntersectionObserver(function (entradas) {
      botonPasado = !entradas[0].isIntersecting;
      actualizarVisibilidad();
    }, { rootMargin: '0px 0px 100000px 0px' }).observe(boton);
    if (MOVIL.addEventListener) MOVIL.addEventListener('change', actualizarVisibilidad);

    // El texto del botón cambia con la talla y con la preventa
    new MutationObserver(sincronizarBoton).observe(boton, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    sincronizarBoton();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();


/* ============================================================
   ESQUINAS — el chat sobre la píldora "Lista de deseos"
   La app de la lista pinta su píldora en la ficha después de cargar, con su
   tamaño (en móvil el tema le quita el texto). El CSS pone el chat encima
   sumando --muare-lista-alto: aquí se mide la píldora y se mantiene al día.
   El corazón va también en la cabecera: se le pide a la app que lo pinte en
   .muare-lista-cabecera (header-actions.liquid) y, cuando ya está ahí,
   <html> lleva data-lista-cabecera y en móvil el CSS esconde la píldora.
   Ver ESQUINAS en theme-custom.css.
   ============================================================ */
(function () {
  // Su config llega después, en el body, y su SDK la lee enseguida: se añade el sitio en el momento en que la página la escribe.
  // shortcut: depende del nombre interno de su config (_metafields.wishlistConfig); si la app lo cambia, no sale en la cabecera y se queda la píldora (como antes)
  var config = window._ReStockConfig = window._ReStockConfig || {};
  var metafields = config._metafields;
  Object.defineProperty(config, '_metafields', {
    configurable: true,
    enumerable: true,
    get: function () { return metafields; },
    set: function (valor) {
      var boton = valor && valor.wishlistConfig && valor.wishlistConfig.access_button;
      if (boton) boton.inline_button_placements = (boton.inline_button_placements || []).concat({ css_selector: '.muare-lista-cabecera', relative_placement: 'start' });
      metafields = valor;
    }
  });

  var PILDORA = '.nm-wishlist-open-list-button';
  var HUECO = 10; // entre la píldora y el chat
  var raiz = document.documentElement;
  var ultimo = null;
  var vigilada = null; // la píldora cuyo tamaño se vigila (cambia al pasar de móvil a escritorio)

  function medir() {
    raiz.toggleAttribute('data-lista-cabecera', !!document.querySelector('.muare-lista-cabecera .nm-wishlist-inline-access-button'));
    var pildora = document.querySelector(PILDORA);
    if (pildora && pildora !== vigilada && window.ResizeObserver) { vigilada = pildora; new ResizeObserver(medir).observe(pildora); }
    var alto = pildora && pildora.getClientRects().length ? pildora.offsetHeight + HUECO : 0;
    if (alto === ultimo) return;
    ultimo = alto;
    if (alto) raiz.style.setProperty('--muare-lista-alto', alto + 'px');
    else raiz.style.removeProperty('--muare-lista-alto');
  }

  function iniciar() {
    medir();
    new MutationObserver(medir).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', medir);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();


/* ============================================================
   ESQUINAS AL DESPLAZAR — en móvil, lo que flota en las esquinas (cookies,
   chat, lista) se va al bajar por la página y vuelve al subir, arriba del
   todo y al llegar al final: el icono de cookies siempre se puede recuperar.
   Con el menú lateral abierto no sale nunca. Con el chat abierto no se va
   (su ✕ está en el botón). Pone data-esquinas-fuera en <html>; ver ESQUINAS
   en theme-custom.css.
   ============================================================ */
(function () {
  var MOVIL = window.matchMedia('(max-width: 749px)');
  var PASO = 10; // px seguidos en un sentido para cambiar: los temblores del dedo no cuentan
  var raiz = document.documentElement;
  var desde = window.scrollY; // donde empezó el último tramo en un sentido
  var bajando = false;
  var pendiente = false;

  function actualizar() {
    pendiente = false;
    var y = window.scrollY;
    var fin = raiz.scrollHeight - window.innerHeight;
    if (Math.abs(y - desde) >= PASO) { bajando = y > desde; desde = y; }
    var menu = document.getElementById('Details-menu-drawer-container');
    var fuera = MOVIL.matches && !document.querySelector('#muare-chat-btn.open') &&
      (!!(menu && menu.open) || (bajando && y > 0 && y < fin - 1));
    if (fuera !== raiz.hasAttribute('data-esquinas-fuera')) raiz.toggleAttribute('data-esquinas-fuera', fuera);
  }

  window.addEventListener('scroll', function () {
    if (!pendiente) { pendiente = true; requestAnimationFrame(actualizar); }
  }, { passive: true });
  // El menú lateral es un <details>: su "toggle" no burbujea, se escucha en captura
  document.addEventListener('toggle', function (evento) {
    if (evento.target.id === 'Details-menu-drawer-container') actualizar();
  }, true);
  if (MOVIL.addEventListener) MOVIL.addEventListener('change', actualizar);
})();


/* ============================================================
   CHAT EN MÓVIL — la caja por encima del teclado
   En iOS el teclado no empuja lo que va fijo abajo: la caja del chat quedaba
   detrás. Con la caja abierta se le deja el área que de verdad se ve
   (visualViewport, la que encoge el teclado): --muare-vv-alto y
   --muare-vv-arriba. Con ellas va en la parte alta y cabe siempre (ESQUINAS en
   theme-custom.css). Solo abierta y en la propia caja: en iOS el área visible
   cambia sin parar al desplazar (la barra de direcciones), y escribir en <html>
   a cada cambio rompía en Safari las transiciones de cookies y chat.
   ============================================================ */
(function () {
  var vv = window.visualViewport;
  if (!vv) return;

  function medir() {
    var caja = document.getElementById('muare-chat-box');
    if (!caja || caja.classList.contains('hidden')) return;
    caja.style.setProperty('--muare-vv-alto', vv.height + 'px');
    caja.style.setProperty('--muare-vv-arriba', vv.offsetTop + 'px');
  }

  vv.addEventListener('resize', medir);
  vv.addEventListener('scroll', medir); // iOS mueve el área visible para enseñar el campo enfocado
  // Al abrirla (la app cambia su clase al pulsar el botón; aquí, ya en burbuja, está hecho) y al enfocar su campo
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#muare-chat-btn')) medir();
  });
  document.addEventListener('focusin', function (e) {
    if (e.target.closest && e.target.closest('#muare-chat-box')) medir();
  });
})();


/* ============================================================
   DESPLEGABLE PROPIO — talla de la ficha, variantes de "Completa el set" e idioma de la cabecera
   El menú nativo de Safari/macOS se abre SOBRE el campo y no se puede
   colocar con CSS. Con ratón se sustituye solo el MENÚ: al pulsar el campo
   se abre una lista propia justo debajo de su línea. El aspecto cerrado no
   cambia:
   - Talla de la ficha e idioma de la cabecera: se queda el <select> del
     tema, con su caja y su tipografía; solo se impide que abra su menú nativo.
   - "Completa el set": el <select> se oculta y lo sustituye un botón con la
     misma línea inferior que tenía.
   En ambos casos el <select> sigue siendo la fuente de verdad: el tema y la
   app leen de él (opciones, data-*) y reaccionan a su evento "change", que se
   lanza al elegir. En táctil se deja el selector nativo del sistema.
   ============================================================ */
(function () {
  var RATON = window.matchMedia('(hover: hover) and (pointer: fine)');
  var REDUCIR = window.matchMedia('(prefers-reduced-motion: reduce)');
  // La ficha de producto, el selector de variante de las tarjetas (diálogo de añadir rápido) y el idioma de la cabecera
  // (escritorio; en móvil va en el menú lateral): mismo desplegable en los tres
  var FICHA = '.product-details select.variant-option__select, #quick-add-dialog select.variant-option__select, .dropdown-localization select.localization-form__select';
  var COMPLETA = 'select.completa-set__variante';
  var abierto = null; // { cerrar: fn, lista: nodo, ancla: nodo }

  // enSeco: sin animación (al desplazar o redimensionar, la lista ya no estaría bajo su campo mientras se pliega)
  function cerrarAbierto(enfocar, enSeco) {
    if (abierto) abierto.cerrar(enfocar, enSeco);
  }

  // Lista de opciones justo debajo de `ancla`. `disparador` recibe el foco al cerrar con teclado; `alElegir` repinta el disparador.
  function abrirLista(select, ancla, disparador, alElegir) {
    cerrarAbierto(false);
    var lista = document.createElement('ul');
    lista.className = 'desplegable__lista';
    lista.setAttribute('role', 'listbox');
    lista.tabIndex = -1;
    var activo = Math.max(0, select.selectedIndex);
    var id = 'desplegable-' + Math.random().toString(36).slice(2, 8);

    Array.prototype.forEach.call(select.options, function (opcion, i) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.id = id + '-' + i;
      li.setAttribute('aria-selected', i === select.selectedIndex ? 'true' : 'false');
      li.textContent = opcion.text.trim();
      li.addEventListener('click', function () { elegir(i, false); });
      li.addEventListener('mousemove', function () { marcar(i); });
      lista.appendChild(li);
    });

    function marcar(i) {
      activo = Math.max(0, Math.min(select.options.length - 1, i));
      Array.prototype.forEach.call(lista.children, function (li, j) { li.classList.toggle('activo', j === activo); });
      lista.setAttribute('aria-activedescendant', lista.children[activo].id);
      lista.children[activo].scrollIntoView({ block: 'nearest' });
    }

    function cerrar(enfocar, enSeco) {
      if (!lista.isConnected || lista.classList.contains('desplegable__lista--cerrando')) return;
      disparador.setAttribute('aria-expanded', 'false');
      abierto = null;
      var quitar = function () { lista.remove(); };
      if (enSeco || REDUCIR.matches) {
        quitar();
      } else {
        // Se pliega con la animación de apertura al revés y después se retira; el temporizador cubre que no llegue a animarse
        lista.classList.add('desplegable__lista--cerrando');
        lista.addEventListener('animationend', quitar, { once: true });
        setTimeout(quitar, 400);
      }
      if (enfocar) disparador.focus(); // solo con teclado: con ratón un foco programático podría pintar el recuadro de foco
    }

    function elegir(i, enfocar) {
      if (i !== select.selectedIndex) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true })); // el tema y la app reaccionan
      }
      if (alElegir) alElegir();
      cerrar(enfocar);
    }

    lista.addEventListener('keydown', function (e) {
      var tecla = e.key;
      if (tecla === 'ArrowDown') marcar(activo + 1);
      else if (tecla === 'ArrowUp') marcar(activo - 1);
      else if (tecla === 'Home') marcar(0);
      else if (tecla === 'End') marcar(select.options.length - 1);
      else if (tecla === 'Enter' || tecla === ' ') elegir(activo, true);
      else if (tecla === 'Escape') { cerrar(true); e.stopPropagation(); } // dentro de un diálogo, que no se cierre también este
      else if (tecla === 'Tab') cerrar(false);
      else return;
      if (tecla !== 'Tab') e.preventDefault();
    });

    // position: fixed y colgada del body: ningún contenedor con scroll u overflow la recorta
    var r = ancla.getBoundingClientRect();
    lista.style.top = r.bottom + 'px';
    lista.style.left = r.left + 'px';
    lista.style.minWidth = r.width + 'px';
    lista.style.maxHeight = Math.max(120, window.innerHeight - r.bottom - 12) + 'px';
    var dialogo = ancla.closest('dialog');
    if (dialogo && lista.showPopover) {
      // Con un diálogo modal abierto el resto de la página es inerte y queda por debajo: la lista cuelga del propio diálogo y,
      // como popover, pasa a la capa superior (sin recortes ni la transformación de la animación del diálogo)
      lista.popover = 'manual';
      dialogo.appendChild(lista);
      lista.showPopover();
    } else {
      document.body.appendChild(lista);
    }
    disparador.setAttribute('aria-expanded', 'true');
    abierto = { cerrar: cerrar, lista: lista, ancla: ancla };
    marcar(select.selectedIndex);
    lista.focus();
  }

  function alternar(select, ancla, disparador, alElegir) {
    if (abierto && abierto.ancla === ancla) cerrarAbierto(true);
    else abrirLista(select, ancla, disparador, alElegir);
  }

  /* --- Talla de la ficha: el <select> del tema se queda; solo se intercepta la apertura de su menú nativo --- */
  function fichaDe(e) {
    var select = RATON.matches && e.target.closest ? e.target.closest(FICHA) : null;
    return select ? { select: select, caja: select.closest('.variant-option__select-wrapper') || select } : null;
  }

  // Delegados en el documento: el tema repinta el selector al cambiar de talla y los listeners propios se perderían
  document.addEventListener('mousedown', function (e) {
    var f = e.button === 0 && fichaDe(e);
    if (!f) return;
    e.preventDefault(); // sin esto el sistema abre su menú sobre el campo
    alternar(f.select, f.caja, f.select);
  }, true);
  document.addEventListener('keydown', function (e) {
    var f = fichaDe(e);
    if (!f || !(e.key === ' ' || e.key === 'Enter' || e.key === 'ArrowDown' || e.key === 'ArrowUp')) return;
    e.preventDefault();
    if (!abierto || abierto.ancla !== f.caja) abrirLista(f.select, f.caja, f.select);
  }, true);

  /* --- "Completa el set": el <select> se oculta y lo sustituye un botón con su misma línea inferior --- */
  function crear(select) {
    var envoltorio = document.createElement('div');
    envoltorio.className = 'desplegable';
    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'desplegable__boton';
    boton.setAttribute('aria-haspopup', 'listbox');
    boton.setAttribute('aria-expanded', 'false');
    var texto = document.createElement('span');
    boton.appendChild(texto);
    envoltorio.appendChild(boton);

    // Solo se escribe si cambia: este nodo está bajo el observador y no debe provocar vueltas
    function refrescar() {
      var elegida = select.options[select.selectedIndex];
      var nuevo = elegida ? elegida.text.trim() : '';
      if (texto.textContent !== nuevo) texto.textContent = nuevo;
    }

    boton.addEventListener('click', function () { alternar(select, boton, boton, refrescar); });
    boton.addEventListener('keydown', function (e) {
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !abierto) { e.preventDefault(); abrirLista(select, boton, boton, refrescar); }
    });
    // La app escucha el clic de toda la ficha para marcar su casilla: el desplegable no debe marcarla
    envoltorio.addEventListener('click', function (e) { e.stopPropagation(); });

    select.parentNode.insertBefore(envoltorio, select);
    select.style.display = 'none';
    envoltorio.refrescar = refrescar;
    envoltorio.select = select;
    refrescar();
  }

  function revisar() {
    // Una sola talla: sin desplegable, ni el nativo (táctil) ni el propio; en su línea se pinta la talla como texto
    // (la app ya eligió esa variante). Solo se escribe si cambia: estos nodos están bajo el observador.
    Array.prototype.forEach.call(document.querySelectorAll(COMPLETA), function (select) {
      if (select.options.length > 1) return;
      var anterior = select.previousElementSibling;
      if (anterior && anterior.classList.contains('desplegable')) anterior.remove();
      if (select.style.display !== 'none') select.style.display = 'none';
      var talla = select.nextElementSibling;
      if (!talla || !talla.classList.contains('completa-set__talla')) {
        talla = document.createElement('div');
        talla.className = 'completa-set__talla';
        talla.appendChild(document.createElement('span')); // como el botón del desplegable: texto dentro, recortable con "…"
        select.parentNode.insertBefore(talla, select.nextSibling);
      }
      var texto = select.options.length ? select.options[0].text.trim() : '';
      if (talla.firstChild.textContent !== texto) talla.firstChild.textContent = texto;
      // Sus vecinas llevan el desplegable propio (con ratón: letra de la ficha, sin margen) o el <select> nativo: entonces se
      // copian su letra (la fija la sección) y su margen de arriba (lo pone la app), para que el texto quede a su altura
      var estilo = RATON.matches ? null : getComputedStyle(select);
      var letra = estilo ? estilo.fontSize : '';
      var margen = estilo ? estilo.marginTop : '';
      if (talla.style.fontSize !== letra) talla.style.fontSize = letra;
      if (talla.style.marginTop !== margen) talla.style.marginTop = margen;
    });
    if (!RATON.matches) return;
    Array.prototype.forEach.call(document.querySelectorAll(COMPLETA), function (select) {
      if (select.options.length < 2) return;
      var anterior = select.previousElementSibling;
      var envoltorio = anterior && anterior.classList.contains('desplegable') ? anterior : null;
      if (envoltorio && envoltorio.select === select) { envoltorio.refrescar(); return; }
      if (envoltorio) envoltorio.remove();
      crear(select);
    });
  }

  function iniciar() {
    revisar();
    // La app pinta las fichas después de cargar la página (y puede repintarlas): se revisa lo que cambie
    new MutationObserver(revisar).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('pointerdown', function (e) {
      if (abierto && !abierto.lista.contains(e.target) && !abierto.ancla.contains(e.target)) cerrarAbierto(false);
    });
    // La lista queda anclada a su sitio solo mientras no se desplaza la página o un contenedor
    window.addEventListener('scroll', function (e) {
      if (abierto && !abierto.lista.contains(e.target)) cerrarAbierto(false, true);
    }, true);
    window.addEventListener('resize', function () { cerrarAbierto(false, true); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();


/* ============================================================
   FLECHAS DE "COMPLETA EL SET"
   La fila de fichas se desliza, pero nada avisa de que hay más. Cuando no
   cabe entera hay flechas a los lados (a la altura de las imágenes); la de
   cada lado se oculta al llegar a su extremo. Con ratón solo se ven al pasar
   el cursor por la fila; en táctil (móvil y tablet), siempre (CSS). Las pinta
   este código porque las fichas las crea la app: se revisa cada vez que la
   página cambia.
   ============================================================ */
(function () {
  var REDUCIR = window.matchMedia('(prefers-reduced-motion: reduce)');
  var idioma = (document.documentElement.lang || 'es').slice(0, 2);
  var ETIQUETAS = {
    es: ['Anterior', 'Siguiente'], en: ['Previous', 'Next'], de: ['Zurück', 'Weiter'],
    fr: ['Précédent', 'Suivant'], it: ['Precedente', 'Successivo'], nl: ['Vorige', 'Volgende']
  };
  var etiquetas = ETIQUETAS[idioma] || ETIQUETAS.es;
  var FLECHA_MITAD = 18; // las flechas miden 36 px

  function crearFlecha(sentido, lista) {
    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'completa-set__flecha completa-set__flecha--' + (sentido < 0 ? 'ant' : 'sig');
    boton.setAttribute('aria-label', etiquetas[sentido < 0 ? 0 : 1]);
    boton.hidden = true;
    boton.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';
    boton.addEventListener('click', function (e) {
      e.stopPropagation(); // la app escucha clics en la ficha para marcar casillas
      var ficha = lista.querySelector('.completa-set__tarjeta');
      var paso = ficha ? ficha.getBoundingClientRect().width + (parseFloat(getComputedStyle(lista).columnGap) || 0) : lista.clientWidth * 0.8;
      lista.scrollBy({ left: sentido * paso, behavior: REDUCIR.matches ? 'auto' : 'smooth' });
    });
    return boton;
  }

  function actualizar(lista) {
    var f = lista._flechas;
    var desborda = lista.scrollWidth - lista.clientWidth > 1;
    f.ant.hidden = !desborda || lista.scrollLeft <= 1;
    f.sig.hidden = !desborda || lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 1;
    // Las imágenes miden lo que da el ancho disponible (base.css): las flechas van a la mitad de su altura real
    var imagen = lista.querySelector('img');
    var imagenMitad = imagen ? imagen.getBoundingClientRect().height / 2 : 70;
    var arriba = lista.getBoundingClientRect().top - lista.parentElement.getBoundingClientRect().top + imagenMitad - FLECHA_MITAD;
    f.ant.style.top = f.sig.style.top = arriba + 'px';
    // La fila mide un número entero de fichas y puede ser más estrecha que su contenedor: la flecha derecha sigue su borde
    f.sig.style.right = 'auto';
    f.sig.style.left = (lista.offsetLeft + lista.clientWidth - 36 - 4) + 'px';
  }

  function revisar() {
    Array.prototype.forEach.call(document.querySelectorAll('.completa-set__lista'), function (lista) {
      var pariente = lista.parentElement;
      if (!lista._flechas || !lista._flechas.ant.isConnected) {
        // La app puede repintar la lista y dejar flechas huérfanas: se parte de cero
        Array.prototype.forEach.call(pariente.querySelectorAll(':scope > .completa-set__flecha'), function (n) { n.remove(); });
        if (getComputedStyle(pariente).position === 'static') pariente.style.position = 'relative';
        lista._flechas = { ant: crearFlecha(-1, lista), sig: crearFlecha(1, lista) };
        pariente.appendChild(lista._flechas.ant);
        pariente.appendChild(lista._flechas.sig);
        lista.addEventListener('scroll', function () { actualizar(lista); }, { passive: true });
        if (window.ResizeObserver) new ResizeObserver(function () { actualizar(lista); }).observe(lista);
      }
      actualizar(lista);
    });
  }

  function iniciar() {
    revisar();
    // La app pinta las fichas después de cargar la página (y puede repintarlas): se revisa lo que cambie
    new MutationObserver(revisar).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', revisar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();


/* ============================================================
   "COMPLETA EL SET": CARRITO EN CADA FICHA, Y CARRITO LATERAL TRAS AÑADIR
   El botón de carrito de la esquina de cada ficha (CSS) añade ese producto
   al carrito al pulsarlo: el carrito se convierte en un tick durante 2 s y
   se abre el carrito lateral del tema unos segundos (las unidades se cambian
   allí). El carrito lateral se comporta igual (sale con retraso y se cierra
   solo) tras añadir desde las tarjetas de producto (añadir rápido, directo o
   con el selector de variante), donde además se marca el tick en el botón de
   la tarjeta.
   La app guarda la variante elegida en la casilla de la ficha (data-vid) y
   añade las marcadas al pulsar el botón del producto principal; aquí la
   casilla ya no se marca (se intercepta el clic), así que ese camino de la
   app queda sin uso. Se añade igual que ella (misma ruta, mismo aviso
   "cart:update" y misma marca _completa_set: 'si', con la que la app mide
   sus ventas en los pedidos): no quitar la marca.
   ============================================================ */
(function () {
  var FICHA = '.completa-set__tarjeta';
  var CASILLA = FICHA + ' > label > input[type="checkbox"]';
  var CLASE_ANADIDO = 'completa-set__tarjeta--anadido';
  var TICK_MS = 2000; // lo que dura el tick antes de volver al carrito
  var CARRITO_MS = 5000; // lo que se queda abierto el carrito lateral
  var RETRASO_CARRITO_MS = 500; // lo que espera el carrito lateral para salir, para que se vea antes el tick
  var cierre;

  function base(raiz) {
    var url = raiz.getAttribute('data-url') || '';
    return url.charAt(url.length - 1) === '/' ? url.slice(0, -1) : url;
  }

  // Como la app: el tema escucha "cart:update" para repintar el carrito y el número del icono
  function refrescarCarrito(ruta) {
    return fetch(ruta + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        // El tema abre el carrito lateral al recibir este aviso: se retrasa un poco
        return new Promise(function (listo) { setTimeout(listo, RETRASO_CARRITO_MS); }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: carrito, sourceId: 'completa-el-set', data: { source: 'completa-el-set', itemCount: carrito.item_count } },
          }));
        });
      })
      .catch(function () {}); // ya está añadido: si falla el repintado no se da por fallido
  }

  function anadir(raiz, variante) {
    var ruta = base(raiz);
    var items = [{ id: Number(variante), quantity: 1, properties: { _completa_set: 'si' } }];
    return fetch(ruta + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status)); // p. ej. una variante que se ha agotado mientras tanto
      document.dispatchEvent(new CustomEvent('completa-set:anadido', { detail: { items: items } }));
      return refrescarCarrito(ruta);
    });
  }

  // Abre el carrito lateral si hace falta (el tema ya lo abre solo con "abrir al añadir" activado) y lo cierra a los pocos segundos
  function mostrarCarrito(abrir) {
    var cajon = document.querySelector('cart-drawer-component');
    if (!cajon) return;
    if ((abrir || !cajon.hasAttribute('auto-open')) && typeof cajon.open === 'function') cajon.open();
    clearTimeout(cierre);
    cierre = setTimeout(function () {
      var dialogo = cajon.querySelector('dialog');
      var interior = cajon.querySelector('.cart-drawer__inner');
      // Si la persona lo está usando (cursor o foco dentro) no se le cierra
      if (!dialogo || !dialogo.open || (interior && (interior.matches(':hover') || interior.contains(document.activeElement)))) return;
      if (typeof cajon.close === 'function') cajon.close();
    }, CARRITO_MS);
  }

  // Tras añadir desde una tarjeta de producto (el tema avisa con "cart:update" desde el formulario de su añadir rápido, o desde el
  // del selector de variante, que va en el diálogo #quick-add-dialog) el carrito lateral sale con retraso, como el de arriba.
  // En captura y en la ventana: va antes que el tema, que lo abriría ya; se le quita el "auto-open" solo durante este aviso.
  window.addEventListener('cart:update', function (e) {
    var datos = (e.detail && e.detail.data) || {};
    var origen = e.target && e.target.closest && e.target.closest('quick-add-component, #quick-add-dialog');
    if (datos.source !== 'product-form-component' || datos.didError || !origen) return;
    var cajon = document.querySelector('cart-drawer-component');
    if (cajon && cajon.hasAttribute('auto-open')) {
      cajon.removeAttribute('auto-open');
      setTimeout(function () { cajon.setAttribute('auto-open', ''); }, 0);
    }
    setTimeout(function () { mostrarCarrito(true); }, RETRASO_CARRITO_MS);
    // Desde el selector de variante el botón de la tarjeta no lo sabe: se le marca el tick (el directo lo marca el tema)
    if (origen.id === 'quick-add-dialog' && datos.productId) {
      var botones = document.querySelectorAll('product-card[data-product-id="' + datos.productId + '"] .quick-add__button');
      Array.prototype.forEach.call(botones, function (boton) {
        boton.classList.add('atc-added');
        setTimeout(function () { boton.classList.remove('atc-added'); }, TICK_MS);
      });
    }
  }, true);

  // En captura y en el documento: va antes que la app, que marcaría la casilla al pulsar cualquier parte de la ficha
  document.addEventListener('click', function (e) {
    var ficha = e.target.closest && e.target.closest(FICHA);
    if (!ficha) return;
    var casilla = e.target.closest(CASILLA);
    if (!casilla) {
      // Sin esto, pulsar el nombre o el hueco de la ficha marcaría una casilla que ya no se ve y se añadiría con el botón de la ficha
      if (!e.target.closest('a, select, button, .desplegable__lista')) e.stopPropagation();
      return;
    }
    e.preventDefault(); // la casilla no cambia de estado
    e.stopPropagation();
    var variante = casilla.getAttribute('data-vid');
    var raiz = document.querySelector('[data-completa-set]');
    if (!variante || !raiz || casilla.disabled || ficha.classList.contains(CLASE_ANADIDO)) return;

    ficha.classList.add(CLASE_ANADIDO);
    var quitar = setTimeout(function () { ficha.classList.remove(CLASE_ANADIDO); }, TICK_MS);
    anadir(raiz, variante).then(function () { mostrarCarrito(false); }).catch(function (error) {
      clearTimeout(quitar);
      ficha.classList.remove(CLASE_ANADIDO); // no se ha añadido: no se confirma
      if (window.console) console.warn('Completa el set: no se pudo añadir al carrito', error);
    });
  }, true);

  // La casilla no tiene texto: se le da nombre para lectores de pantalla ("Añadir <producto>", con el texto de la app)
  function nombrar() {
    var raiz = document.querySelector('[data-completa-set]');
    if (!raiz) return;
    var verbo = raiz.getAttribute('data-t-anadir') || 'Añadir';
    Array.prototype.forEach.call(document.querySelectorAll(CASILLA + ':not([aria-label])'), function (casilla) {
      var nombre = casilla.closest(FICHA).querySelector('.completa-set__nombre');
      casilla.setAttribute('aria-label', verbo + (nombre ? ' ' + nombre.textContent.trim() : ''));
    });
  }

  // Su proxy da los títulos siempre en español: fuera del español se cambian, antes de que los pinte, por los del producto en el
  // idioma de la página (/<idioma>/products/<handle>.js, como la tienda los traduce). Si algo falla, le llega su respuesta tal cual.
  var fetchOriginal = window.fetch;
  var PROXY_SET = /\/apps\/completa-el-set\/set\//;

  function traducirSet(respuesta, idioma) {
    if (!respuesta.ok) return respuesta;
    return respuesta.clone().json().then(function (datos) {
      return Promise.all(((datos && datos.recomendaciones) || []).map(function (p) {
        return fetchOriginal.call(window, idioma + '/products/' + p.handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (producto) {
            if (!producto) return;
            p.titulo = producto.title;
            (p.variantes || []).forEach(function (v) {
              var suya = producto.variants.filter(function (x) { return String(x.id) === String(v.id); })[0];
              if (suya && v.titulo) v.titulo = suya.title;
            });
          })
          .catch(function () {});
      })).then(function () {
        return new Response(JSON.stringify(datos), { status: respuesta.status, headers: { 'Content-Type': 'application/json' } });
      });
    }).catch(function () { return respuesta; });
  }

  window.fetch = function (recurso) {
    var args = arguments;
    var raiz = document.querySelector('[data-completa-set]');
    var idioma = ((raiz && raiz.getAttribute('data-url')) || '').replace(/\/$/, ''); // '/en'; en español, vacío
    if (idioma && PROXY_SET.test(String(recurso))) {
      return fetchOriginal.apply(window, args).then(function (r) { return traducirSet(r, idioma); });
    }
    return fetchOriginal.apply(window, args);
  };

  function iniciar() {
    nombrar();
    // La app pinta las fichas después de cargar la página: se revisa lo que cambie
    new MutationObserver(nombrar).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();


/* ============================================================
   FICHA — "COMPLETA EL SET" BAJO LA FOTO (de 1151 a 1355 px)
   Con la galería a la izquierda y los detalles a la derecha, al estrechar
   la ventana los detalles crecen más que la foto y bajo ella queda un hueco
   en blanco. Para aprovecharlo, "Completa el set" se pasa a una fila propia
   bajo la foto y los detalles, centrada en la ventana (columna central de la
   sección, con el margen de página a cada lado).
   De 750 a 1150 px la ficha va en una sola columna (base.css) y ya queda todo
   bajo la foto (detalles, desplegables y "Completa el set", en ese orden): no
   hace falta mover nada. Fuera de esos anchos, el bloque vuelve a su sitio.
   ============================================================ */
(function () {
  var M_COMPLETA = window.matchMedia('(min-width: 1151px) and (max-width: 1355px)');
  var hueco = null; // { marca: comentario del sitio original, nodo: el bloque de la app }

  function inventariar() {
    var completa = document.querySelector('.product-details .completa-set');
    var envoltorio = completa && completa.closest('.shopify-app-block');
    if (!envoltorio) return null;
    var marca = document.createComment('origen-bajo-foto');
    envoltorio.parentNode.insertBefore(marca, envoltorio);
    return { marca: marca, nodo: envoltorio };
  }

  function acomodar() {
    var grid = document.querySelector('.product-information__grid');
    if (!grid || !grid.parentNode) return;
    if (!hueco) hueco = inventariar();
    if (!hueco || !hueco.marca.parentNode) return;
    var contenedor = grid.parentNode.querySelector(':scope > .pdp-bajo-foto');
    if (!M_COMPLETA.matches) { // a su sitio original (solo si no está ya)
      if (hueco.nodo.previousSibling !== hueco.marca) hueco.marca.parentNode.insertBefore(hueco.nodo, hueco.marca.nextSibling);
      if (contenedor) contenedor.remove();
      return;
    }
    if (!contenedor) {
      contenedor = document.createElement('div');
      contenedor.className = 'pdp-bajo-foto';
      grid.insertAdjacentElement('afterend', contenedor); // hijo de la sección, no de la columna de la foto
    }
    if (hueco.nodo.parentNode !== contenedor) contenedor.appendChild(hueco.nodo);
  }

  function iniciar() {
    acomodar();
    M_COMPLETA.addEventListener('change', acomodar);
    // El editor de temas repinta la sección entera: se parte de cero
    document.addEventListener('shopify:section:load', function () { hueco = null; acomodar(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

/* ============================================================
   MENÚ MÓVIL — ACORDEÓN CON ANIMACIÓN SUAVE (Muaré)
   Los grupos del menú salen plegados y se despliegan/pliegan animando la altura. Se usa la Web Animations API
   porque la animación del tema depende de `interpolate-size`/::details-content, que no tienen todos los navegadores.
   ============================================================ */
(function () {
  var DURACION = 380;
  var CURVA = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var sinAnimacion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function medidas(el) {
    var cs = getComputedStyle(el);
    return { alto: el.getBoundingClientRect().height, arriba: cs.paddingBlockStart, abajo: cs.paddingBlockEnd };
  }

  function fotograma(alto, arriba, abajo, opacidad) {
    return { blockSize: alto, paddingBlockStart: arriba, paddingBlockEnd: abajo, opacity: opacidad };
  }

  function animar(det, contenido, abrir) {
    det.dataset.animando = '';
    if (abrir) det.open = true;
    else det.dataset.cerrando = '';
    var m = medidas(contenido);
    var cerrado = fotograma('0px', '0px', '0px', 0);
    var abierto = fotograma(m.alto + 'px', m.arriba, m.abajo, 1);
    var anim = contenido.animate(abrir ? [cerrado, abierto] : [abierto, cerrado], {
      duration: DURACION,
      easing: CURVA,
      fill: 'forwards'
    });
    anim.onfinish = function () {
      if (!abrir) det.open = false;
      anim.cancel();
      delete det.dataset.animando;
      delete det.dataset.cerrando;
    };
  }

  document.addEventListener(
    'click',
    function (e) {
      var resumen = e.target.closest && e.target.closest('header-drawer accordion-custom > details > summary');
      if (!resumen) return;
      var det = resumen.parentElement;
      var contenido = det.querySelector(':scope > .details-content');
      if (!contenido || !contenido.animate || sinAnimacion.matches) return; // sin animación: se queda el comportamiento nativo
      e.preventDefault();
      if ('animando' in det.dataset) return;
      animar(det, contenido, !det.open);
    },
    true
  );

  // Al cerrar el menú, los grupos vuelven a plegarse para que la próxima vez se abra como al principio.
  document.addEventListener(
    'toggle',
    function (e) {
      var menu = e.target;
      if (!menu.matches || !menu.matches('header-drawer > details') || menu.open) return;
      menu.querySelectorAll('accordion-custom > details[open]').forEach(function (d) {
        d.open = false;
      });
    },
    true
  );
})();

/* ============================================================
   FLECHAS DE LAS TIRAS DE SUBCOLECCIONES (TODOS · REDONDOS · XL…)
   Las tiras de las páginas de colección se deslizan en horizontal. Cuando no caben enteras salen flechas circulares a los
   lados: al pulsarlas la tira avanza (o retrocede) como mucho hasta su extremo, nunca más allá. Los enlaces se difuminan antes
   de llegar a cada flecha (máscara en base.css, que se activa con las clases tira--antes / tira--despues según haya más
   enlaces a cada lado). Cada flecha se oculta en su extremo. Todas las tiras están dentro de .filters-section
   (sections/section.liquid), así que se detectan desde aquí sin tocar sus snippets.
   ============================================================ */
(function () {
  var TIRAS = '.filters-section nav';
  var FUNDIDO = 80; // px difuminados a cada lado (base.css): un paso avanza lo que queda nítido entre los dos
  var REDUCIR = window.matchMedia('(prefers-reduced-motion: reduce)');
  var idioma = (document.documentElement.lang || 'es').slice(0, 2);
  var ETIQUETAS = {
    es: ['Anterior', 'Siguiente'], en: ['Previous', 'Next'], de: ['Zurück', 'Weiter'],
    fr: ['Précédent', 'Suivant'], it: ['Precedente', 'Successivo'], nl: ['Vorige', 'Volgende']
  };
  var etiquetas = ETIQUETAS[idioma] || ETIQUETAS.es;

  function crearFlecha(sentido, tira) {
    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'tira-flecha tira-flecha--' + (sentido < 0 ? 'ant' : 'sig');
    boton.setAttribute('aria-label', etiquetas[sentido < 0 ? 0 : 1]);
    boton.hidden = true;
    boton.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
    boton.addEventListener('click', function () {
      var maximo = tira.scrollWidth - tira.clientWidth;
      var paso = Math.max(tira.clientWidth - 2 * FUNDIDO, tira.clientWidth / 2);
      var destino = Math.max(0, Math.min(maximo, tira.scrollLeft + sentido * paso)); // nunca más allá del extremo
      tira.scrollTo({ left: destino, behavior: REDUCIR.matches ? 'auto' : 'smooth' });
    });
    return boton;
  }

  function actualizar(tira) {
    var f = tira._flechas;
    var desborda = tira.scrollWidth - tira.clientWidth > 1;
    var antes = desborda && tira.scrollLeft > 1;
    var despues = desborda && tira.scrollLeft + tira.clientWidth < tira.scrollWidth - 1;
    f.ant.hidden = !antes;
    f.sig.hidden = !despues;
    tira.classList.toggle('tira--antes', antes);
    tira.classList.toggle('tira--despues', despues);
    // Centradas en la tira (el pariente es el que las coloca: position: relative)
    f.ant.style.top = f.sig.style.top = tira.offsetTop + tira.offsetHeight / 2 + 'px';
  }

  // El elemento que se desliza es el propio <nav> o, en alguna tira (mascotas), el <div> que lo envuelve
  function deslizante(nav) {
    var candidatos = [nav, nav.parentElement];
    for (var i = 0; i < candidatos.length; i++) {
      var ox = getComputedStyle(candidatos[i]).overflowX;
      if (ox === 'auto' || ox === 'scroll') return candidatos[i];
    }
    return null;
  }

  function revisar() {
    Array.prototype.forEach.call(document.querySelectorAll(TIRAS), function (nav) {
      var tira = deslizante(nav);
      if (!tira) return;
      tira.classList.add('tira-desplazable');
      if (!tira._flechas || !tira._flechas.ant.isConnected) {
        var pariente = tira.parentElement;
        if (getComputedStyle(pariente).position === 'static') pariente.style.position = 'relative';
        tira._flechas = { ant: crearFlecha(-1, tira), sig: crearFlecha(1, tira) };
        pariente.appendChild(tira._flechas.ant);
        pariente.appendChild(tira._flechas.sig);
        tira.addEventListener('scroll', function () { actualizar(tira); }, { passive: true });
        if (window.ResizeObserver) new ResizeObserver(function () { actualizar(tira); }).observe(tira);
      }
      actualizar(tira);
    });
  }

  function iniciar() {
    revisar();
    window.addEventListener('load', revisar); // con las tipografías cargadas cambia el ancho de la tira
    window.addEventListener('resize', revisar);
    document.addEventListener('shopify:section:load', revisar); // editor de temas
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
